module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H16.172c-.552 0-1.316.316-1.708.708L.586 14.586a1.998 1.998 0 0 0 0 2.828l14 14a1.998 1.998 0 0 0 2.828 0l13.878-13.878c.392-.392.708-1.156.708-1.708V2c0-1.106-.894-2-2-2zm-8 14c-2.208 0-4-1.792-4-4s1.792-4 4-4 4 1.792 4 4-1.792 4-4 4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/tag-1.js
// module id = 1445
// module chunks = 14